import { render, staticRenderFns } from "./FileQuestionView.vue?vue&type=template&id=0cde02a2&scoped=true&"
import script from "./FileQuestionView.vue?vue&type=script&lang=ts&"
export * from "./FileQuestionView.vue?vue&type=script&lang=ts&"
import style0 from "./FileQuestionView.vue?vue&type=style&index=0&id=0cde02a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cde02a2",
  null
  
)

export default component.exports